import { AuthenticateClient } from './fo.api.service';

const API_URL = window.config?.VITE_API_HOST;

class UserService {
  client = null;

  constructor(token) {
    this.client = new AuthenticateClient(API_URL);
    this.client.setAuthToken(token);
  }

  getUsers(params) {
    return new Promise((resolve, reject) => {
      this.client
        .paginatedUserList(params)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getPaginatedUsers(params) {
    return new Promise((resolve, reject) => {
      this.client
        .paginatedUserList(params)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  registerUser(registration) {
    return new Promise((resolve, reject) => {
      this.client
        .register(registration)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  updateRegistration(registration) {
    return new Promise((resolve, reject) => {
      this.client
        .updateRegistration(registration)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  addRole(role) {
    return new Promise((resolve, reject) => {
      this.client
        .addRole(role)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  setRole(role) {
    return new Promise((resolve, reject) => {
      this.client
        .setRole(role)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  removeRole(role) {
    return new Promise((resolve, reject) => {
      this.client
        .removeRole(role)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  updatePassword(password) {
    return new Promise((resolve, reject) => {
      this.client
        .updatePassword(password)
        .then((response) => {
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default UserService;
